module.exports = "/images/config.svg?cb3777b6e3635075df175ff85a6956a5";